import 'overlayscrollbars/overlayscrollbars.css'
import './assets/css/main.css'
import './plugins/iconify-local'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueFeather from 'vue-feather'
import PageHeaderVue from './components/ui/PageHeader.vue'
import Icon from '@/components/ui/Icon.vue'
import { useAuthStore } from '@/stores/auth'
import colResize from '@/directives/colResize'
import { abilitiesPlugin } from '@casl/vue'
import { ability } from '@/plugins/casl'

import App from './App.vue'
import router from './plugins/router'
import { applyDocumentLocale, getSavedLocale, i18n } from './plugins/i18n'

const app = createApp(App)

// Initialize locale + direction before the app renders.
const initialLocale = getSavedLocale()
applyDocumentLocale(initialLocale)
i18n.global.locale.value = initialLocale

app.component(VueFeather.name, VueFeather)
app.component('PageHeader', PageHeaderVue)
app.component('Icon', Icon)
app.directive('col-resize', colResize)
const pinia = createPinia()
app.use(pinia)
app.use(abilitiesPlugin, ability, { useGlobalProperties: true })

app.use(i18n)

// Resolve user + permissions BEFORE installing the router so the first
// navigation's guard sees populated ability rules (otherwise the guard
// denies every permissioned route → redirect loop → white screen).
const authStore = useAuthStore(pinia)
;(async () => {
  await authStore.hydrateUser()
  app.use(router)
  await router.isReady()
  app.mount('#app')
})()
